import iBS03ADV_ResultType from '../model/iBS03ADV_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS03ADV_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "voltage", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS03ADV_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS03ADV_Result;
